class SuddenlinkidsController {
  constructor($state ,$rootScope,storage,laboxSSapi) {
    this.name = 'Usernames';
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.suddenlinkidsLoader = true;
    this.totalOptIdCount = (storage.getItem('session', 'maxIdAvailable'));
    this.errorWhileLoading = false;

    this.keyWatch = event => {
      window.addEventListener('keydown', this.keydown,false);
    };

    this.keydown = (event)=> {
      event.stopPropagation();
      if(event.keyCode === 27 || event.keyCode === 8 || event.keyCode ===461){
        window.removeEventListener('keydown', this.keydown);
        this.$rootScope.fromSuddenlinkIdPage = true;
        this.$state.go('home.landingpage');
      }
    };

    laboxSSapi.getAllSuddenlinkIds().then((res) => {
      if(res && res.data && res.data.accountSummaryResponse.statusDescription && res.data.accountSummaryResponse.statusDescription == "Success"){
        this.unregUser = res.data.accountSummaryResponse.users[0].userName.search("unreg:") + 1;
        console.log('this.unregUser is ' + this.unregUser);
        if (this.unregUser !== 1) {

          console.log('get all suddenlink id response --> ',res.users);
          storage.setItem('session','suddenlink_ids',res.data.accountSummaryResponse.users);
          storage.setItem('session','suddenlink_primary_id',res.data.accountSummaryResponse.primaryId);
          console.log('suddenlink primary id is set up in session storage');
          this.items = res.data.accountSummaryResponse.users.map(item => {
            //this.items = optids.map(item => {
            return {
              label: item.userName,
              data: item.firstName + ' ' + item.lastName
            };
          });

          this.currentOptIdCount = (storage.getItem('session', 'suddenlink_ids')).length;
          this.itemsLength = this.currentOptIdCount;
          this.optPrimary = storage.getItem('session', 'suddenlink_primary_id');
          this.hasSuddenlinkId = (storage.getItem('session', 'hasSuddenlinkId'));
          this.suddenlinkidsLoader = false;
          setTimeout(function() {
            document.getElementById('next-btn').focus();
          }, 100);
        } else {
          this.errorWhileLoading = true;
          this.hasSuddenlinkId = false;
          this.$rootScope.fromSuddenlinkIdPage = true;
          this.$state.go('home.landingpage');
        }
      }
      else {
        this.hasSuddenlinkId = false;
        this.suddenlinkidsLoader = false;
        this.$rootScope.fromSuddenlinkIdPage = true;
        this.$state.go('home.landingpage');
        this.errorWhileLoading = true;
      }
    });
  }
}

SuddenlinkidsController.$inject = ['$state', '$rootScope', 'storage', 'laboxSSapi'];

export default SuddenlinkidsController;



// WEBPACK FOOTER //
// ./client/app/components/suddenlinkids/suddenlinkids.controller.js